import { Component, Vue } from 'vue-property-decorator';
import WithRender from './notFound.html';

@WithRender
@Component
export default class NotFoundPage extends Vue {

}
